import { Component, OnInit, OnDestroy, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { Subscription } from 'rxjs';

import { FiscalDataId, FiscalDataService } from '../../services/fiscal-data.service';
import { CountryService } from '../../services/country.service';
import { StateService } from '../../services/state.service';
import { Globals, SelectOption } from '../../globals';
import { CFDI, CustomerBillData } from '../../services/customer-bill.service';
import { AddressId, AddressService } from '../../services/address.service';
import { PayrollId } from '../../services/catalogs-settings.service';
import { FirestoreService } from '../../services/firestore/firestore.service';
import { toast } from 'angular2-materialize';
import { Utils } from '../../util';
import { CompanyData } from '../../services/company.service';
import { PostalCodeCatalog } from '../../../catalogs/postalCode';
import { Autocomplete } from '../../coms/autocomplete/autocomplete.component';

function notRequiredEmailValidator(control: FormControl) {
  if (!control.value) {
      return null;
  }

  return Validators.email(control);
}

@Component({
  selector: 'app-create-fiscal-data',
  templateUrl: './create-fiscal-data.component.html',
  styleUrls: ['./create-fiscal-data.component.css']
})
export class CreateFiscalDataComponent implements OnInit, OnDestroy {

  parent: string;
  customerOrSupplier: string;

  fiscalDataForm: FormGroup;
  cfdiForm: FormGroup;
  cfdiSelects: any = {};
  fiscalData: any = [];

  id: string;

  countries: any[] = [];
  @Input() countryInit: string;
  @Output() countryModelChange = new EventEmitter();

  states: any[] = [];
  @Input() stateInit: string;
  @Output() stateModelChange = new EventEmitter();

	localitys: {name: string, value: string}[] = Utils.Object.keys(Globals.LOCALITYS).map(lockKey => ({name: `${lockKey}, ${Globals.LOCALITYS[lockKey].state}`, value: lockKey})).sort((a, b) => a.name > b.name ? 1 : -1);
	locality: string = '';

	municipilatys: {name: string, value: string}[] = Utils.Object.keys(Globals.MUNICIPALITYS).map(munKey => ({name: `${munKey}, ${Globals.MUNICIPALITYS[munKey].state}`, value: munKey})).sort((a,b) => a.name > b.name ? 1 : -1);
	municipality: string = '';

  fiscalRegimenSelect: SelectOption[] = [];
  postalCodeAutocomplete: Autocomplete<string> = new Autocomplete('postalCode', '* Código postal', PostalCodeCatalog.select, postalCode => this.fiscalDataForm.get('postCode').setValue(postalCode || ''));

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private fiscalDataService: FiscalDataService,
    private customerBillData: CustomerBillData,
    private countryService: CountryService,
    private stateService: StateService,
    private fsService: FirestoreService,
    private addressService: AddressService,
    private companyData: CompanyData,
  ) {
    this.cfdiSelects = customerBillData.allSelects;
    this.fiscalRegimenSelect = Utils.Object.keys(this.companyData.fiscalRegimenSelect).map(key => ({ value: key, name: this.companyData.fiscalRegimenSelect[key].full }));

		this.parent = this.activatedRoute.parent.snapshot.paramMap.get('id');
		this.customerOrSupplier = this.activatedRoute.parent.snapshot.data['customerOrSupplier'];
    this.loadCountriesAndStates();
  }

  ngOnInit() {
    this.fiscalDataForm = this.formBuilder.group({
      businessName: ['', Validators.required],
      rfc: ['', Validators.required],
      neighborhood: ['', Validators.required],
      street: ['', Validators.required],
      externalNumber: ['', Validators.required],
      internalNumber: '',
      municipality: '',
      state: ['', Validators.required],
      country: ['', Validators.required],
      email: ['', notRequiredEmailValidator],
      email2: ['', notRequiredEmailValidator],
      phone: '',
      creditLimitAmount: '',
      creditLimitDays: '',
      creditLimitAmountInside: '',
      creditLimitDaysInside: '',
      accountingCode: '',
      notes: '',
      postCode: ['', Validators.required],
      fiscalRegimen: <FiscalDataId['fiscalRegimen']>'key0',
    });

    this.cfdiForm = this.formBuilder.group(<CFDI>{
      payForm: 'key0',
      payMethod: 'key0',
      payConditions: 'key0',
      cfdiUsage: 'key0',
      //currency: 'key0',
      //change: 1,
      bankDigits: ''
    });
  }
  ngOnDestroy() {
  }

  async onSubmitFiscalData() {
    this.fiscalData = this.saveFiscalData();

    this.fiscalData.cfdi = this.cfdiForm.value;

    this.fiscalDataService.addFiscalData(this.fiscalData);
    if(confirm('Agregar este domicilio también a Direcciones de Oficinas?\nOk: Sí\nCancelar: No')) await this.copyToAddress();
    this.fiscalDataForm.reset();

    if(this.customerOrSupplier == 'customerId'){
      this.router.navigate(['/vw_customer/' + this.parent + '/fiscalData']);
    }else if(this.customerOrSupplier == 'supplierId'){
      this.router.navigate(['/vw_supplier/' + this.parent + '/fiscalData']);
    }
  }
  async copyToAddress(){
    console.log(this.fiscalData);
    let settings = await this.fsService.docWithId<PayrollId>(`${Globals.CATALOGS_SETTINGS}/1`);
    if(!settings) return toast('Error copiando dirección.', 2000);
    //console.log(settings);
    settings.folios.address++;
    let folio = `DE${Utils.String.fillLeft(`${settings.folios.address}`, '0', 6)}`;
    //console.log(folio);
    await this.fsService.update(`${Globals.CATALOGS_SETTINGS}/1`, {folios: settings.folios});
    let newAddress: AddressId = {
      id: '',
      folio,
      active: true,
      city: '',
      countryId: this.fiscalData.countryId,
      createdAt: new Date(),
      customerId: this.fiscalData.customerId || '',
      email: this.fiscalData.email,
      email2: this.fiscalData.email2,
      externalNumber: this.fiscalData.externalNumber,
      internalNumber: this.fiscalData.internalNumber,
      mobile: '',
      municipality: '',
      neighborhood: this.fiscalData.neighborhood,
      phone: this.fiscalData.phone,
      phone2: '',
      stateId: this.fiscalData.stateId,
      street: this.fiscalData.street,
      supplierId: this.fiscalData.supplierId || '',
      typeId: 1 as any,
      updatedAt: new Date(),
      zipCode: this.fiscalData.postCode,
      xlocality: this.fiscalData.xlocality,
      xmunicipality: this.fiscalData.xmunicipality,
      requiresCartaPorte: false,
    };
    delete newAddress.id;
    this.addressService.addAddress(newAddress);
    alert(`Se añadió la dirección con folio: ${folio}`);
  }
  saveFiscalData() {
		var customerId = '';
		var supplierId = '';
		if(this.customerOrSupplier == 'customerId') {
			customerId = this.parent;
		} else if (this.customerOrSupplier == 'supplierId'){
			supplierId = this.parent;
		}

    const fiscalDataJson = {
      businessName: this.fiscalDataForm.get('businessName').value,
      countryId: this.fiscalDataForm.get('country').value,
      municipality: this.fiscalDataForm.get('municipality').value,
      customerId: customerId,
      supplierId: supplierId,
      email: this.fiscalDataForm.get('email').value,
      email2: this.fiscalDataForm.get('email2').value,
      phone: this.fiscalDataForm.get('phone').value,
      externalNumber: this.fiscalDataForm.get('externalNumber').value,
      internalNumber: this.fiscalDataForm.get('internalNumber').value,
      neighborhood: this.fiscalDataForm.get('neighborhood').value,
      rfc: this.fiscalDataForm.get('rfc').value,
      stateId: this.fiscalDataForm.get('state').value,
      street: this.fiscalDataForm.get('street').value,
      creditLimitAmount: this.fiscalDataForm.get('creditLimitAmount').value,
      creditLimitDays: this.fiscalDataForm.get('creditLimitDays').value,
      creditLimitAmountInside: this.fiscalDataForm.get('creditLimitAmountInside').value,
      creditLimitDaysInside: this.fiscalDataForm.get('creditLimitDaysInside').value,
      accountingCode: this.fiscalDataForm.get('accountingCode').value,
      notes: this.fiscalDataForm.get('notes').value,
      postCode: this.fiscalDataForm.get('postCode').value,
      xlocality: this.locality,
      xmunicipality: this.municipality,
      fiscalRegimen: this.fiscalDataForm.get('fiscalRegimen').value,
    };

    return fiscalDataJson;
  }
    	
	getBack() {
		if(this.customerOrSupplier == 'customerId'){
			this.router.navigate(['/vw_customer/' + this.parent + '/fiscalData']);
		} else if(this.customerOrSupplier == 'supplierId'){
			this.router.navigate(['/vw_supplier/' + this.parent + '/fiscalData']);
		}
	}
  
  loadCountriesAndStates() {
		this.countries = Utils.Object.keys(Globals.COUNTRIES).map(key => ({id$: key, name: Globals.COUNTRIES[key].name}) );
		this.countryInit = '1';
		this.states = Utils.Object.keys(Globals.STATES).map(key => ({id$: key, name: Globals.STATES[key].name}) );
		this.stateInit = '1';
  }
  changeCountry(countryValue) {
    this.countryModelChange.emit(countryValue);
  }
  changeState(stateValue) {
    this.stateModelChange.emit(stateValue);
  }

}
